/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOverflowSolid = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.77 9a2.77 2.77 0 1 1 0 5.538A2.77 2.77 0 0 1 2.77 9zM12 9a2.77 2.77 0 1 1 0 5.538A2.77 2.77 0 0 1 12 9zm9.23 0a2.77 2.77 0 1 1 0 5.538 2.77 2.77 0 0 1 0-5.538z"
      />
    </svg>
  ),
);
